export enum SectionStatus {
  notAttempted,
  incomplete,
  completed
}
